import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {TextInputFieldComponent, NumberInputFieldComponent, SliderInputFieldComponent, CheckboxInputFieldComponent, PasswordInputFieldComponent, RadioInputFieldComponent, DropDownInputFieldComponent} from './component';

export class InputFieldContentModel extends BaseContentModel {

    static get _slots() {
        return {
            label: "",
            value: "",
            placeholder: "",
            tooltip: "",
            variable: "",
            errorMessage: "",
            disabled: false,
            isReadOnly: false,
            required: false,
            css: "",
            tabindex: 0,
        };
    }

    static get _defaults() {
        return {
            label: "Input Field Label",
            value: "",
            placeholder: "Placeholder Text",
            tooltip: "This is a helpful tooltip",
            variable: "G:UserInputField_Sample:G",
            errorMessage: "This variable is not valid.",
            disabled: false,
            isReadOnly: false,
            required: true,
            css: "",
            tabindex: 0,
        };
    }

    @observable
    /* @slot */ label = "";

    @observable
    /* @slot */ value = "";

    @observable
    /* @slot */ placeholder = "";

    @observable
    /* @slot */ tooltip = "";

    @observable
    /* @slot */ variable = "";

    @observable
    /* @slot */ errorMessage = "";

    @observable
    /* @slot */ disabled = false;

    @observable
    /* @slot */ isReadOnly = false;

    @observable
    /* @slot */ required = false;

    @observable
    /* @slot */ css = "";

    @observable
    /* @slot */ tabindex = "";
}


export class TextInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            minLength: 0,
            maxLength: 0,
            validationRegex: "",
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            minLength: 0,
            maxLength: 100,
            validationRegex: "",
        });
    }

    // define the default Component (Sim) view of this component
    Component = TextInputFieldComponent

    @observable
    /* @slot */ minLength = 0;

    @observable
    /* @slot */ maxLength = 0;

    @observable
    /* @slot */ validationRegex = "";
}


export class NumberInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            min: 0,
            max: 0,
            decimals: 0,
            displayformat: "",
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            min: 0,
            max: 100,
            decimals: 2,
            displayformat: "$0,0.00",
        });
    }

    // define the default Component (Sim) view of this component
    Component = NumberInputFieldComponent

    @observable
    /* @slot */ min = 0;

    @observable
    /* @slot */ max = 0;

    @observable
    /* @slot */ decimals = 0;
    
    @observable
    /* @slot */ displayformat = "";
}


export class SliderInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            min: 0,
            max: 0,
            step: 0,
            ticks: 0,
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            min: 0,
            max: 100,
            step: 0.25,
            ticks: 11,
        });
    }

    // define the default Component (Sim) view of this component
    Component = SliderInputFieldComponent

    @observable
    /* @slot */ min = 0;

    @observable
    /* @slot */ max = 100;

    @observable
    /* @slot */ step = 1;

    @observable
    /* @slot */ ticks = 0;
}


export class CheckboxInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots);
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults);
    }

    // define the default Component (Sim) view of this component
    Component = CheckboxInputFieldComponent
}


export class PasswordInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            minLength: 0,
            maxLength: 0,
            validationRegex: "",
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            minLength: 0,
            maxLength: 100,
            validationRegex: "",
        });
    }

    // define the default Component (Sim) view of this component
    Component = PasswordInputFieldComponent

    @observable
    /* @slot */ minLength = 0;

    @observable
    /* @slot */ maxLength = 0;

    @observable
    /* @slot */ validationRegex = "";
}


export class RadioInputFieldOptionContentModel extends BaseContentModel {
    
        static get _slots() {
            return {
                value: "",
                label: "",
            };
        }
    
        static get _defaults() {
            return {
                value: "1",
                label: "Default Label",
            };
        }
    
        @observable
        /* @slot */ value = "1";
        
        @observable
        /* @slot */ label = "1";
    }

export class RadioInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            options: [RadioInputFieldOptionContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            options: [new RadioInputFieldOptionContentModel({value: 1, label: "Radio Button 1"}), new RadioInputFieldOptionContentModel({value: 2, label: "Radio Button 2"}), new RadioInputFieldOptionContentModel({value: 3, label: "Radio Button 3"})]
        });
    }

    // define the default Component (Sim) view of this component
    Component = RadioInputFieldComponent

    @observable.shallow
    /* @slot */ options = [];
}

export class DropDownInputFieldOptionContentModel extends BaseContentModel {
    
        static get _slots() {
            return {
                value: "",
                label: "",
            };
        }
    
        static get _defaults() {
            return {
                value: "1",
                label: "Default Label",
            };
        }
    
        @observable
        /* @slot */ value = "1";
        
        @observable
        /* @slot */ label = "Option 1";
    }

export class DropDownInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            options: [DropDownInputFieldOptionContentModel]
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            options: [new DropDownInputFieldOptionContentModel({value: 1, label: "Option 1"}), new DropDownInputFieldOptionContentModel({value: 2, label: "Option 2"}), new DropDownInputFieldOptionContentModel({value: 3, label: "Option 3"})]
        });
    }

    // define the default Component (Sim) view of this component
    Component = DropDownInputFieldComponent;

    @observable.shallow
    /* @slot */ options = [];
}


export class TextAreaInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
            minLength: 0,
            maxLength: 0,
            showCounter: false,
            validationRegex: "",
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
            minLength: 0,
            maxLength: 100,
            showCounter: true,
            validationRegex: "",
        });
    }

    // define the default Component (Sim) view of this component
    Component = TextAreaInputFieldComponent

    @observable
    /* @slot */ minLength = 0;

    @observable
    /* @slot */ maxLength = 0;

    @observable
    /* @slot */ showCounter = true;

    @observable
    /* @slot */ validationRegex = "";
}



/*export class DateInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
        });
    }
}*/




export default TextInputFieldContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/inputFields/contentmodel.js